<template>
  <div class="eda-dashboard">
    <div v-if="error" class="error-message">
      {{ error }}
    </div>
    <iframe
      v-else
      :src="edaUrl"
      class="eda-iframe"
      ref="edaIframe"
      @load="handleIframeLoad"
    ></iframe>
  </div>
  <div v-if="isLoading" class="loader-container-eda">
    <div class="loader">
      <div class="spinner"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "EDADashboard",
  data() {
    return {
      error: null,
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
    edaUrl() {
      const token = localStorage.getItem("authToken");
      console.log(token,'token'); 
      const tenantId = this.$route.path.split('/')[1];
      console.log(tenantId,'tenantId');
      
      if (!token || !tenantId) {
        this.error = "Authentication required";
        this.$router.push('/login');
        return null;
      }

      const edaBaseUrl = process.env.VUE_APP_EDA_URL;
      const analysis = this.$route.path.split('/')[3] || 'inventory-analysis'; 
      const darkMode = this.isDarkMode ? 'true' : 'false';
      const url = `${edaBaseUrl}?token=${token}&tenantId=${tenantId}&analysis=${analysis}&darkMode=${darkMode}`;
      console.log('EDA URL:', url);
      return url;
    }
  },
  mounted() {
    // Show loader on initial mount
    this.isLoading = true;
    // Hide loader after 3 seconds on initial load
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  },
  methods: {
    handleIframeLoad() {
      const iframe = this.$refs.edaIframe;
      if (iframe) {
        this.error = null;
        // Add message listener for token expiration
        window.addEventListener('message', this.handleIframeMessage);
        
        // Hide loader after 3 seconds
        setTimeout(() => {
          this.isLoading = false;
        }, 3000);
      }
    },
    handleIframeMessage(event) {
      // Check if the message is from the EDA iframe
      if (event.origin === process.env.VUE_APP_EDA_URL) {
        const data = event.data;
        if (data && data.type === 'TOKEN_EXPIRED') {
          this.handleTokenExpiration();
        }
      }
    },
    handleTokenExpiration() {
      // Clear local storage
      localStorage.removeItem("authToken");
      // Show error message
      this.error = "Your session has expired. Please login again.";
      // Redirect to login page
      this.$router.push('/login');
    }
  },
  watch: {
    // Watch for route path changes to update iframe when analysis changes
    '$route.path'(newPath, oldPath) {
      // Only trigger if we're switching between different EDA analysis types
      if (newPath !== oldPath && newPath.includes('exploratory-data-analysis')) {
        if (this.$refs.edaIframe) {
          this.isLoading = true; // Show loader when URL changes
          this.$refs.edaIframe.src = this.edaUrl;
          // Hide loader after 3 seconds
          setTimeout(() => {
            this.isLoading = false;
          }, 3000);
        }
      }
    },
    // Watch for dark mode changes to update iframe
    isDarkMode() {
      if (this.$refs.edaIframe) {
        this.isLoading = true; // Show loader when URL changes
        this.$refs.edaIframe.src = this.edaUrl;
        // Hide loader after 3 seconds
        setTimeout(() => {
          this.isLoading = false;
        }, 3000);
      }
    }
  },
  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener('message', this.handleIframeMessage);
  }
};
</script>

<style scoped>
.eda-dashboard {
  width: 100%;
  height: calc(100vh - 64px);
  position: relative;
}

.eda-iframe {
  width: 100%;
  min-height: 100%;
  border: none;
}

.loader-container-eda {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  z-index: 10;
}

.loader {
  text-align: center;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 4px solid #145B80;
  border-top: 4px solid #f8f9fa;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  margin: 0 auto 16px;
}

.dark-mode .spinner {
  border-color: #145B80;
  border-top: 4px solid #1F2937 !important;
}

.loading-text {
  margin: 0;
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 20px;
  color: #dc3545;
  background: #f8f9fa;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Dark mode styles */
.v-application--is-dark .loader-container {
  background: #1F2937;
}

.v-application--is-dark .spinner {
  border-color: #424242;
  border-top-color: #64b5f6;
}

.v-application--is-dark .loading-text {
  color: #e0e0e0;
}
</style> 